import { useNotification } from "components/Notification/useAddNotification";

export const useRemindPasswordNotification = () => {
  const { addNotification } = useNotification();

  const notificationTitle = "Przypomnienie hasła";

  const showSuccessNotification = () =>
    addNotification({
      title: notificationTitle,
      description: "Pomyślnie wysłano mail z linkiem",
      type: "success",
    });

  const showErrorNotification = (description?: string) =>
    addNotification({
      title: notificationTitle,
      description: description ?? "Nie udało się wysłać maila",
      type: "error",
    });

  return { showSuccessNotification, showErrorNotification };
};
